<div class="col-md-12 text-center valign">
  <h1>404</h1>
  <h2>The requested page does not exist.</h2>
</div>
